import { TabConfig } from '../models/tab-config'
import { ProductField } from './product-fields'
import { PRODUCT_MISC_FIELD_IDS } from './product-misc-field-ids'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'

export const WISHLIST_FILTER_TABS: TabConfig[] = [
  {
    id: ProductField.Activity,
    name: 'ACTIVITY',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.activity'
  },
  {
    id: ProductField.Family,
    name: 'FAMILY',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.family'
  },
  {
    id: ProductField.Line,
    name: 'LINE',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.line'
  },
  {
    id: ProductField.Color,
    name: 'COLOR',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.color'
  },
  {
    id: ProductField.WholesaleFreeTag,
    name: 'FREE TAG',
    clientTypes: [VIPClientType.External], // should only be visible to whl clients
    key: 'filter.whlFreeTag'
  },
  {
    id: ProductField.RetailFreeTag,
    name: 'FREE TAG',
    clientTypes: [VIPClientType.Internal], // should only be visible to rtl clients
    key: 'filter.rtlFreeTag'
  },
  {
    id: ProductField.Material,
    name: 'MATERIAL',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.material'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.RECOMMENDED_PRODUCTS,
    name: 'RECOMMENDED PRODUCTS',
    clientTypes: [VIPClientType.External], // should only be visible to whl clients
    key: 'filter.recommendedProducts'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.LOOK_NAME,
    name: 'LOOK',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.look'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.CORE_PRODUCTS,
    name: 'CORE PRODUCTS',
    clientTypes: [VIPClientType.Internal], // should only be visible to rtl clients
    key: 'filter.coreProducts'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.CLUSTERS,
    name: 'CLUSTERS',
    clientTypes: [VIPClientType.Internal], // should only be visible to rtl clients
    key: 'filter.clusters'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.CAPSULE,
    name: 'CAPSULE',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.capsule'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.DROP,
    name: 'DROP',
    clientTypes: [VIPClientType.External],
    key: 'filter.drop'
  },
  {
    id: PRODUCT_MISC_FIELD_IDS.RETAILSALESPERIOD,
    name: 'RETAIL SALES PERIOD',
    clientTypes: [VIPClientType.Internal], // should only be visible to rtl clients
    key: 'filter.retailSalesPeriod'
  }
]
